var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useEffect, useState } from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import { Combobox, Transition } from '@headlessui/react';
import { Textarea } from "@/components/ui/textarea";
export default function AddressTextarea(_a) {
    var value = _a.value, onChange = _a.onChange, _b = _a.onCountryChange, onCountryChange = _b === void 0 ? null : _b, _c = _a.typesFilter, typesFilter = _c === void 0 ? '' : _c, _d = _a.countryFilter, countryFilter = _d === void 0 ? '' : _d;
    var _e = useState(""), address = _e[0], setAddress = _e[1];
    var google = window.google;
    var _f = useState((value || {})), addressData = _f[0], setAddressData = _f[1];
    // useEffect(() => {
    //     if (Object.keys(addressData).length) {
    //         onChange(addressData);
    //     } else {
    //         onChange(null);
    //     }
    // }, [addressData]);
    function handleChange(address) {
        setAddress(address);
    }
    // catch this event: document.dispatchEvent(new CustomEvent('address', {detail: value}));
    // and use it to set the address
    useEffect(function () {
        var fn = function (e) {
            // setAddress(e.detail);
        };
        document.addEventListener('address', fn);
        return function () {
            document.removeEventListener('address', fn);
        };
    });
    function handleSelect(address, placeId) {
        if (!placeId) {
            return;
        }
        console.log('handleSelect', address, placeId);
        // setAddress("");
        var map = new google.maps.Map(document.getElementById("map"), {});
        var request = {
            placeId: placeId,
            fields: ['address_component']
        };
        var service = new google.maps.places.PlacesService(map);
        service.getDetails(request, callback);
        function callback(place, status) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
            console.log('address callback', place, status, address);
            if (status == google.maps.places.PlacesServiceStatus.OK) {
                var streetNumber = (_c = (_b = (_a = place.address_components.filter(function (a) { return a.types.filter(function (t) { return t === "street_number"; }).length; })) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.long_name) !== null && _c !== void 0 ? _c : '';
                var premise = (_f = (_e = (_d = place.address_components.filter(function (a) { return a.types.filter(function (t) { return t === "premise"; }).length; })) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.long_name) !== null && _f !== void 0 ? _f : '';
                var street = (_j = (_h = (_g = place.address_components.filter(function (a) { return a.types.filter(function (t) { return t === "route"; }).length; })) === null || _g === void 0 ? void 0 : _g[0]) === null || _h === void 0 ? void 0 : _h.long_name) !== null && _j !== void 0 ? _j : '';
                var line_1 = [streetNumber, street].filter(Boolean).join(' ');
                if (!streetNumber && premise) { // we don't have a street number but there is a premise
                    line_1 = [premise, street].filter(Boolean).join(', ');
                }
                if (!streetNumber && !premise) { //neither? did the search start with a number like 12a?
                    //copy it in
                    var matches = address.match(/^\d+[a-z]\b/i);
                    if (matches && matches[0]) {
                        streetNumber = matches[0];
                        line_1 = [streetNumber, street].filter(Boolean).join(' ');
                    }
                }
                var postalCode = (_m = (_l = (_k = place.address_components.filter(function (a) { return a.types.filter(function (t) { return t === "postal_code"; }).length; })) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.long_name) !== null && _m !== void 0 ? _m : '';
                var country = (_q = (_p = (_o = place.address_components.filter(function (a) { return a.types.filter(function (t) { return t === "country"; }).length; })) === null || _o === void 0 ? void 0 : _o[0]) === null || _p === void 0 ? void 0 : _p.long_name) !== null && _q !== void 0 ? _q : '';
                var countryIso = (_s = (_r = place.address_components.filter(function (a) { return a.types.filter(function (t) { return t === "country"; }).length; })) === null || _r === void 0 ? void 0 : _r[0]) === null || _s === void 0 ? void 0 : _s.short_name;
                var postalTown = (_v = (_u = (_t = place.address_components.filter(function (a) { return a.types.filter(function (t) { return t === "postal_town"; }).length; })) === null || _t === void 0 ? void 0 : _t[0]) === null || _u === void 0 ? void 0 : _u.long_name) !== null && _v !== void 0 ? _v : '';
                var town = (_y = (_x = (_w = place.address_components.filter(function (a) { return a.types.filter(function (t) { return t === "sublocality_level_1"; }).length; })) === null || _w === void 0 ? void 0 : _w[0]) === null || _x === void 0 ? void 0 : _x.long_name) !== null && _y !== void 0 ? _y : '';
                var ad = {
                    line_1: line_1,
                    city: postalTown,
                    town: town,
                    post_code: postalCode,
                    // country: country
                };
                var addStr = Object.values(ad).filter(Boolean).join("\n");
                console.log('addStr:', addStr);
                onChange(addStr, countryIso);
            }
        }
    }
    ;
    var searchOptions = {
        componentRestrictions: { country: countryFilter }
    };
    if (typesFilter) {
        searchOptions.types = [typesFilter];
    }
    return (_jsxs("div", __assign({ className: "space-y-2" }, { children: [_jsx("div", { children: _jsx(PlacesAutocomplete, __assign({ value: address, onChange: handleChange, onSelect: handleSelect, searchOptions: searchOptions, debounce: 500 }, { children: function (_a) {
                        var getInputProps = _a.getInputProps, suggestions = _a.suggestions, getSuggestionItemProps = _a.getSuggestionItemProps, loading = _a.loading;
                        var inputProps = getInputProps({
                            placeholder: 'Search...',
                            className: 'focus:ring-sky-500 focus:border-sky-500 block w-full pl-10 sm:text-sm border-gray-300 rounded-full opacity-50 focus:opacity-100',
                            id: 'address',
                            type: 'search'
                        });
                        inputProps.autoComplete = "never";
                        return _jsxs(_Fragment, { children: [_jsx("div", { id: "map" }), _jsx(Combobox, __assign({ value: address, onChange: function () {
                                    } }, { children: function (_a) {
                                        var open = _a.open;
                                        return (_jsxs(_Fragment, { children: [_jsxs("div", __assign({ className: "mt-1 relative rounded-full shadow-sm", id: "address_search_holder" }, { children: [_jsx("div", __assign({ className: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, { children: _jsx(MagnifyingGlassIcon, { className: "h-5 w-5 text-gray-400", "aria-hidden": "true" }) })), _jsx(Combobox.Input, __assign({}, inputProps))] })), _jsx(Transition, __assign({ show: open, enter: "transition duration-100 ease-out", enterFrom: "transform scale-95 opacity-0", enterTo: "transform scale-100 opacity-100", leave: "transition duration-75 ease-out", leaveFrom: "transform scale-100 opacity-100", leaveTo: "transform scale-95 opacity-0" }, { children: _jsxs(Combobox.Options, __assign({ className: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm max-w-lg", static: true }, { children: [loading && _jsx("div", __assign({ className: " odd:bg-gray-100 py-2 px-4 bg-white" }, { children: "Loading..." })), suggestions.map(function (suggestion, i) {
                                                                return (_jsx(Combobox.Option, __assign({ value: suggestion }, getSuggestionItemProps(suggestion, {
                                                                    className: "cursor-pointer odd:bg-gray-100 py-2 px-4 ".concat(suggestion.active ? "bg-sky-200 odd:bg-sky-200" : "bg-white"),
                                                                }), { children: suggestion.description }), i));
                                                            })] })) }))] }));
                                    } }))] });
                    } })) }), _jsx(Textarea, { placeholder: "Address...", className: "border-gray-300", value: value, onChange: function (e) { return onChange(e.currentTarget.value); } })] })));
}
